/** Strip Lovable "Edit with Lovable" overlay if injected after load (preview / hosted builds). */
export function removeLovableBadge(): void {
  document.getElementById('lovable-badge')?.remove();

  document.querySelectorAll<HTMLElement>('a[href*="lovable.dev"]').forEach((el) => {
    const text = el.textContent?.toLowerCase() ?? '';
    if (text.includes('vesta') || text.includes('financial intel')) {
      el.remove();
    }
  });
}

export function watchForLovableBadge(): void {
  removeLovableBadge();
  if (typeof MutationObserver === 'undefined' || !document.body) return;

  const observer = new MutationObserver(() => removeLovableBadge());
  observer.observe(document.body, { childList: true, subtree: true });
}
